import { ReactNode } from 'react';
import { Sheet } from 'react-modal-sheet';
import { SheetModalContainer, SheetModalContent } from './style';

export interface SheetModalProps {
	isOpen?: boolean;
	disableDrag?: boolean;
	onClose?: () => void;
	header?: ReactNode;
	children?: ReactNode;
	heightPercentage?: number;
}

export function SheetModal({
	isOpen = false,
	disableDrag = false,
	children,
	header,
	heightPercentage,
	onClose = () => {},
}: SheetModalProps) {
	return (
		<Sheet
			isOpen={isOpen}
			disableDrag={disableDrag}
			onClose={onClose}
		>
			<SheetModalContainer
				heightPercentage={heightPercentage}
				style={{ borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}
			>
				<Sheet.Header>{header}</Sheet.Header>
				<Sheet.Content>
					<SheetModalContent>{children}</SheetModalContent>
				</Sheet.Content>
			</SheetModalContainer>
			<Sheet.Backdrop onTap={onClose} />
		</Sheet>
	);
}
